import React, { useEffect } from 'react';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';
import Cookies from 'js-cookie';
import { getLinkToEdit } from '@panel/core/src/utils/getPublisherLinks';
import { sendTrackingInfo } from '../sendTrackingInfo';
import { selectColor } from '../../core';
import { getColor } from '../../core/themev3';
import Alert from '../../../avisos/src/components/Alert/Alert';

const PerformanceTips = ({
  tips,
  inDrawer,
  postingId,
  datalayerText,
  isDuplicate,
  device,
  isIntegrator,
  isAssistant,
  publicationType
}) => {
  const { publisherTypeId, isSeeker } = useSelector(userInfoSelectors.getuserInfoState);
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  const { t } = useTranslation();
  const isDevelopment = publicationType !== 'Clasificado';
  const userIsParticular = publisherTypeId === '1' || isSeeker;
  const isBrasilSite = siteId.includes('BR');

  const PercentageFormatter = percent => Math.round(percent) || 1;

  const handleClick = () => {
    sendTrackingInfo('Panel', 'Mis avisos', datalayerText);
    window.location.href = `${window.location.origin}${getLinkToEdit(
      userIsParticular,
      bumexFeatures,
      postingId,
      isDevelopment
    )}`;
  };
  useEffect(() => {
    const statusPanel = Cookies.get('statusPanel');
    if (!statusPanel && isIntegrator) {
      Cookies.set('statusPanel', true, {
        expires: 1
      });
    }
  }, [isIntegrator]);

  return (
    <Container inDrawer={inDrawer} isBrasilSite={isBrasilSite} device={device} isIntegrator={isIntegrator}>
      <h3 data-panel='panel-modal-performanceTips-title'>{t('panel.desempeno.calidad.consejos.titulo')}</h3>
      <div className='layout'>
        <ul data-panel='panel-modal-performanceTips-tipList'>
          {tips.map(tip => {
            return (
              <li
                data-panel={`panel-modal-performanceTips-tipList-tip-${tip.advice}`}
                className='tip-container'
                key={tip.advice}
              >
                <div className='decorator' />
                <div className='tip-text-container'>{`${tip.advice} ${
                  isDuplicate && tip.message ? tip.message.replaceAll(',', ', ') : ''
                } ${tip.percentage_to_improve ? `(+${PercentageFormatter(tip.percentage_to_improve)}%)` : ''}`}</div>
              </li>
            );
          })}
        </ul>
      </div>
      {isIntegrator && (
        <AlertContainer>
          <Alert isNeutral fontSize='14px'>
            {t('panel.avisos.publish.modal.alert.integrador')}
          </Alert>
        </AlertContainer>
      )}
      {!isAssistant && (
        <Button data-panel='panel-modal-performanceTips-cta-edit' onClick={handleClick} isIntegrator={isIntegrator}>
          {t('panel.desempeno.calidad.consejos.editar')}
        </Button>
      )}
    </Container>
  );
};

const Button = styled.button`
  background-color: ${getColor('primary')};
  color: ${selectColor('white')};
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
  margin-top: ${({ isIntegrator }) => (isIntegrator ? '0' : '10')}px;
  :hover {
    background-color: ${getColor('secondary')};
  }
`;

const Container = styled.div`
  ${({ inDrawer }) =>
    inDrawer &&
    css`
      margin-top: 50px;
    `}
  padding:25px 25px 25px 25px;
  height: ${({ device }) => (device === 'mobile' ? 'fit-content' : '100%')};
  ${({ isBrasilSite }) =>
    isBrasilSite &&
    css`
      height: ${({ device }) => (device === 'mobile' ? 'fit-content' : '90%')};
    `}
  box-sizing: border-box;
  > div {
    > ul {
      ${({ device }) =>
        device === 'mobile' &&
        css`
          max-height: 250px;
          margin-bottom: 20px;
        `}
    }
    overflow: auto;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
    }
    ::-webkit-scrollbar:vertical {
      width: 8px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 20px;
      border: 8px solid ${selectColor('grayMediumLight')};
    }
  }
  .layout {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: ${({ isIntegrator }) => (isIntegrator ? '42%' : '70%')};
  }
  h3 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 10px;
    white-space: normal;
    line-height: 30px;
    margin-top: ${({ device }) => device === 'mobile' && '8px'};
  }
  li {
    font-size: 16px;
    width: 100%;
    white-space: normal;
    color: ${selectColor('grayDark')};
    display: flex;
    margin-bottom: 16px;
  }
  .decorator {
    width: 8px;
    height: 8px;
    background-color: ${selectColor('grayDark')};
    border-radius: 4px;
    margin: 8px 8px 0 0;
  }
  .tip-container {
    display: flex;
    .tip-text-container {
      width: 90%;
      white-space: break-spaces;
      user-select: text;
      -moz-user-select: text;
      -webkit-user-select: text;
      -ms-user-select: text;
    }
  }
`;

const AlertContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export default PerformanceTips;
